const styles = (theme) => ({
    numberInputWrapper: {
        position: 'relative',
        width: '100%',
        display: 'flex',
        alignItems: 'center',
    },
    numberInput: {
        width: '100%',
        padding: '14px',
        paddingRight: '30px',
        border: `1px solid ${theme.palette.primary.main}`,
        borderRadius: 10,
        backgroundColor: 'white',
        fontSize: '1rem',
        textAlign: 'left',
        '&:focus': {
            outline: 'none',
            borderColor: theme.palette.primary.dark,
        },
        '&::-webkit-inner-spin-button, &::-webkit-outer-spin-button': {
            '-webkit-appearance': 'none',
            margin: 0,
        },
        '-moz-appearance': 'textfield',
    },
    arrows: {
        position: 'absolute',
        right: 5,
        top: 7,
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
    },
    arrowButton: {
        background: 'none',
        border: 'none',
        cursor: 'pointer',
        padding: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        '&:hover': {
            color: theme.palette.primary.dark,
        },
        '&:focus': {
            outline: 'none',
        },
    },
});

export default styles;
